import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';

@customElement('gz-chat-notice')
export class GzChatNoticeWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  message = '';

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="main-container">
        <gz-icon
          name='ds-icon-notification_info'
          size='24'
        ></gz-icon>
        <gz-text fontSize="10">${this.message}</gz-text>
      </div>
    `;
  }

  constructor() {
    super();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-chat-notice': GzChatNoticeWebComponent;
  }
}
